export default __webpack_public_path__ + "static/media/DJI_0549.78f8b650.jpg";